import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useQuery } from "src/Hooks/useReactQuery";
import { getProjectInstancesDetail } from "src/services/project-instances";
import APP_ROUTES from "src/routes/routes";

const useGetInstanceDetail = (id) => {
  const navigate = usePatchedNavigate();

  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    queryKey: ["project-instance-detail", id],
    queryFn: () => getProjectInstancesDetail(id),
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
    cacheTime: 0,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    refetch,
    isLoading,
    isError,
    error,
    isFetching,
  };
};

export default useGetInstanceDetail;
